import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import QRPayment from "./QRPayment";
import QRPaymentError from "./QRPaymentError";

// Importa Bootstrap desde CDN en el HTML principal, si estás usando React puro
// <link
//   rel="stylesheet"
//   href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
// />

const QRGenerator = () => {
  const { id_pedido, email } = useParams();
  const [qrImage, setQrImage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDone, setIsDone] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const [subtotal, setSubtotal] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);

  const generateQR = async () => {
    setIsLoading(true);
    //despues quitar
    let url = "https://integraciones.casaideas.com.bo/api/orders/getorderById"

    try {
      const responseOrder = await axios.post(
        url,
        // "https://egytvizxl0.execute-api.sa-east-1.amazonaws.com/api/orders/getorderById",
        {
          orderid: id_pedido,
          order_id: id_pedido,
          email: email,
          languageid: 3,
          userId: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(responseOrder)
      if (responseOrder.data.success) {
        let order = responseOrder.data.response[0].order_info
        
        setSubtotal(order.SUBTOTAL - order.DISCOUNT);
        setShippingCost(order.SHIPPINGCOST);
        //console.log("subtotal", subtotal);
        //console.log("shippingCost", shippingCost);

        const totalAmount =
          order.SUBTOTAL + order.SHIPPINGCOST - order.DISCOUNT;


        const response = await axios.post(
          process.env.REACT_APP_GENERATEQR_URL + "/api/web/generateQr",
          {
            order_id: parseInt(id_pedido),
            amount: totalAmount,
            gloss: "Casaideas Bolivia Pedido " + id_pedido,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response?.data?.qrImage) {
          setQrImage(response.data.qrImage);
          setIsDone(true);
        } else {
          setQrImage("/img/error-qr.png");
          setIsDone(true);
        }
      } else {
        setIsValid(false);
      }
    } catch (error) {
      console.error("Error al generar QR:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    generateQR();
  }, []);

  return isValid ? (
    <QRPayment
      isLoading={isLoading}
      email={email}
      qrImageUrl={qrImage}
      items={[{ name: "compras", price: subtotal, quantity: 1 }]}
      subtotal={subtotal}
      shippingCost={shippingCost}
      total={subtotal + shippingCost}
    />
  ) : (
    <QRPaymentError id_pedido={id_pedido} />
  );
};

export default QRGenerator;
